"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSL = void 0;
function viewSL(props) {
    return {
        constructor: function (props) { },
        events: {
            onChange: this.props.onChange,
            onUpdate: this.props.onUpdate,
            onCountryChange: this.props.onCountryChange
        }
    };
}
exports.viewSL = viewSL;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationContactDetails/ViewSL.js
// module id = 271
// module chunks = 0 1